<template>
    <div class="mdui-container mdui-text-left" id="main-content">
        <div class="mdui-center mdui-typo ask_paper">
            <article class="mine">
                <h1 class="mdui-text-color-indigo">特别声明</h1>
                <p>本网站为个人学习与交流所用。</p>
                <p>运营与维护均与<a href="http://yys.163.com/" target="_blank">网易公司</a>无关！</p>
                <p>所有内容版权为<a href="http://yys.163.com/" target="_blank">网易公司</a>所有！</p>
                <p>本站遵守服务器所在地区法律，请勿用于非法用途！</p>
            </article>
        </div>
        <div class="mdui-center mdui-typo ask_paper">
            <article class="mine">
                <h1 class="mdui-text-color-indigo">关于作者</h1>
                <p>你可以叫我"白云无尽"，坐标江苏某城市。</p>
                <p>什么都想学，却也什么都没能学精的咸鱼一只。</p>
                <p>只能用用别人的轮子勉强维持一下生活。</p>
            </article>
        </div>
        <div class="mdui-center mdui-typo ask_paper">
            <article class="mine">
                <h1 class="mdui-text-color-indigo">关于本站</h1>
                <p>始于我在2017年一边瞎鼓捣Android一边肝痒痒鼠时的一个小想法。</p>
                <p>Android版在这里：<a href="https://www.coolapk.com/apk/227193" target="_blank">传送门->酷安</a></p>
                <p>由于<del>无(tài)暇(guì)学习</del>iOS开发，又做了一个网页版。</p>
                <p>19年4月份发现了十分强大的Vue.js，6月使用Vue.js重构网站。</p>
            </article>
        </div>
    </div>
</template>

<script>
    export default {
        name: "About",
        data(){
            return{
                title: "关于",
            }
        },
        methods:{

        },
        beforeMount() {
            this.$emit("titleChanged", this.title);
        }
    }
</script>

<style scoped>
    .ask_paper{
        box-shadow: 0 7px 8px -4px rgba(0,0,0,.2), 0 12px 17px 2px rgba(0,0,0,.14), 0 5px 22px 4px rgba(0,0,0,.12);
        padding:15px 5px 15px 5px;
        width: 100%;
        /*max-width: 800px;*/
        margin: 30px auto 30px auto;
        z-index: 3;
        box-sizing: border-box;
        border-radius: 7px 7px;
        background-color: #fff;;
    }
    article.mine{
        padding: 0 25px 5px 25px;
    }
</style>


// WEBPACK FOOTER //
// src/components/About.vue